var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("各省")]),_c('Table',{staticClass:"table",attrs:{"border":"","columns":_vm.columns1,"data":_vm.ProvinceGroupInfos}}),_c('h1',[_vm._v("各地市")]),_c('Table',{staticClass:"table",attrs:{"border":"","align":"center","columns":_vm.columns4,"data":_vm.CityGroupInfos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }